import { React } from "react";
import useAxios from "../../utilities/useAxios";
import PageTitle from "../PageTitle";
import { Card, Table, Button, message, Input, Modal } from "antd";
import { useEffect, useState } from "react";
import { ClearOutlined } from "@ant-design/icons";

const UpdateMenuCount = () => {
	const [menuList, setMenuList] = useState([]);
	const [loading, setLoading] = useState(true);
	const [editingId, setEditingId] = useState(null);
	const [editingValue, setEditingValue] = useState("");

	const columns = [
		{
			title: "메뉴 이름",
			dataIndex: "name",
			key: "name",
			align: "center",
		},
		{
			title: "항목 수",
			dataIndex: "count",
			key: "count",
			align: "center",
			render: (text, record) => {
				if (editingId === record.id) {
					return (
						<div
							style={{
								display: "flex",
								gap: "8px",
								justifyContent:
									"center",
							}}>
							<Input
								type="number"
								value={
									editingValue
								}
								onChange={(e) =>
									setEditingValue(
										e
											.target
											.value
									)
								}
								style={{
									width: "80px",
								}}
							/>
							<Button
								type="primary"
								onClick={() =>
									handleConfirm(
										record.id
									)
								}>
								확인
							</Button>
						</div>
					);
				}
				return text;
			},
		},
		{
			title: "수정",
			key: "action",
			align: "center",
			render: (_, record) => (
				<Button
					type="primary"
					onClick={() => handleEdit(record)}>
					수정
				</Button>
			),
		},
	];

	const handleEdit = (record) => {
		setEditingId(record.id);
		setEditingValue(record.count.toString());
	};

	const handleConfirm = async (id) => {
		try {
			const response = await useAxios.put(
				`/bethlehem/menu/${id}/`,
				{
					count: parseInt(editingValue),
				}
			);

			if (response.status === 200) {
				message.success("항목 수가 수정되었습니다.");
				setMenuList(
					menuList.map((item) =>
						item.id === id
							? {
									...item,
									count: parseInt(
										editingValue
									),
							  }
							: item
					)
				);
				setEditingId(null);
			}
		} catch (error) {
			message.error("항목 수 수정에 실패했습니다.");
		}
	};

	const handleInitialize = async () => {
		Modal.confirm({
			title: "모든 항목 수 초기화",
			content: "모든 메뉴의 항목 수를 0으로 초기화하시겠습니까?",
			okText: "초기화",
			cancelText: "취소",
			onOk: async () => {
				try {
					setLoading(true);
					const response = await useAxios.put(
						"/bethlehem/menu/initialize/"
					);
					if (response.status === 200) {
						message.success(
							"모든 항목 수가 초기화되었습니다."
						);
						fetchMenuList();
					}
				} catch (error) {
					message.error(
						"항목 수 초기화에 실패했습니다."
					);
				} finally {
					setLoading(false);
				}
			},
		});
	};

	const fetchMenuList = async () => {
		try {
			setLoading(true);
			const response = await useAxios.get("/bethlehem/menu/");
			if (response.status === 200) {
				const sortedMenuList = response.data.sort(
					(a, b) => a.id - b.id
				);
				setMenuList(sortedMenuList);
			}
		} catch (error) {
			message.error("메뉴 목록을 불러오는데 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchMenuList();
	}, []);

	return (
		<div className="bethlehem__menu_count__container">
			<div
				style={{
					display: "flex",
					flexDirection: "row-reverse",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: "16px",
				}}>
				<PageTitle title="메뉴 항목 수" />
				<div style={{ display: "flex", gap: "8px" }}>
					<Button
						type="primary"
						danger
						icon={<ClearOutlined />}
						onClick={handleInitialize}
						loading={loading}>
						초기화
					</Button>
				</div>
			</div>
			<Card>
				<Table
					columns={columns}
					dataSource={menuList}
					loading={loading}
					rowKey="id"
					pagination={false}
				/>
			</Card>
		</div>
	);
};

export default UpdateMenuCount;
